import { z } from 'zod';
import { Option } from '../../types/Option';

const protocolValues = [
    'modbus-tcp-ip',
    'modbus-rtu',
    'can',
    'canopen',
    'mqtt',
    'nats',
    'iec-61850',
    'rest-api',
    'power-line-communication',
    'snmp',
    'io-link',
    'ethernet-ip',
    'opc-ua',
    'profinet',
    'ocpp1.6',
    'ocpp2.0',
    'ocpp2.1',
    'j1939',
] as const;

type CommunicationProtocol = (typeof protocolValues)[number];

const options: Option<CommunicationProtocol>[] = [
    { value: 'modbus-tcp-ip', label: 'Modbus TCP/IP' },
    { value: 'modbus-rtu', label: 'Modbus RTU' },
    { value: 'can', label: 'CAN' },
    { value: 'canopen', label: 'CANopen' },
    { value: 'mqtt', label: 'MQTT' },
    { value: 'nats', label: 'NATS' },
    { value: 'iec-61850', label: 'IEC 61850' },
    { value: 'rest-api', label: 'REST API' },
    { value: 'power-line-communication', label: 'Power line communication' },
    { value: 'snmp', label: 'SNMP' },
    { value: 'io-link', label: 'IO-Link' },
    { value: 'ethernet-ip', label: 'EtherNet/IP' },
    { value: 'opc-ua', label: 'OPC UA' },
    { value: 'profinet', label: 'PROFINET' },
    { value: 'ocpp1.6', label: 'OCPP 1.6' },
    { value: 'ocpp2.0', label: 'OCPP 2.0' },
    { value: 'ocpp2.1', label: 'OCPP 2.1' },
    { value: 'j1939', label: 'J1939' },
];

export const CommunicationProtocols = {
    validator: z.array(z.enum(protocolValues)),
    options,
};

export type CommunicationProtocols = z.infer<typeof CommunicationProtocols.validator>;
